import { createContext } from 'react';
import type { Theme } from './themes';
import { defaultTheme } from './themes';

export const ThemeContext = createContext<Theme>(defaultTheme);
